module.exports = __webpack_public_path__ + "static/media/guess.6053f392.jpg";